<template>
  <div id="desktop">
    <router-view class="desktop-header" name='header'></router-view>
    <div id="overview-flex">
      <div v-if="$route.name !== 'details'" class="sidebar-flex">
        <router-view class="desktop-following" name='sidebar'></router-view>
      </div>
      <div v-else class="sidebar-details-flex">
        <router-view class="desktop-following" name='sidebar'></router-view>
      </div>
      <div id="profile-map-flex">
        <router-view class="desktop-map" name='map'></router-view>
        <router-view v-if="this.showProfile" class="desktop-profile" name='profile'></router-view>
      </div>
      <!--<bird class="sidebarBird"></bird>-->
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  export default{
    name: 'desktop',
    components: {
    },
    computed: {
      ...mapGetters({
        race: 'race',
        route: 'route'
      }),
      showProfile () {
        return this.race.tracking_type !== "App\\Tracking\\NoRoute" && this.route.length > 0;
      }
    }
  }
</script>
<style>
#desktop {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
}

#overview-flex {
  display: flex;
  flex-direction: row;
  flex: 1;
  overflow-y: hidden;
}

.sidebarBird {
  display: flex;
  flex-direction: column;
  flex: 0 0 364px;
  overflow-y: hidden !important;
}

#overview-flex > .sidebarBird {
  flex: 0 0 364px;
  overflow-y: hidden;
}

.sidebar-flex {
  display: flex;
  flex-direction: column;
  flex: 0 0 365px;
  overflow-y: hidden !important;
}

#profile-map-flex {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: hidden;
}

#desktop > .desktop-header {
  flex: 0 0 70px;
}

#profile-map-flex > .desktop-map {
  flex: 1;
  overflow-y: hidden;
}
#profile-map-flex > .sidebar-details-flex > .desktop-details {
  flex: 0 0 1000px;
  width: 1000px;
	background-color: #242f36;
  z-index: 7;
  order: 4;
}

#overview-flex > .sidebar-flex {
  flex: 0 0 365px;
  overflow-y: hidden;
}

#overview-flex > .sidebar-details-flex {
  flex: 0 0 1000px;
  overflow-y: hidden;
}

#overview-flex > .sidebar-flex > .desktop-sidebar {
  flex: 0 0 50px;
  order: 0;
  overflow-y: hidden !important;
}

#overview-flex > .sidebar-flex > .desktop-following {
  flex: 1;
  order: 3;
}

#overview-flex > .sidebar-flex > .desktop-athlete {
  flex: 1;
  order: 5;
  z-index: 1;
  overflow-y: scroll;
  margin-bottom: 53px;
}

#overview-flex > .sidebar-flex > .desktop-search {
  flex: 0 0 36px;
  order: 1;
  overflow-y: hidden;
}

#overview-flex > .sidebar-flex > .desktop-cat {
  flex: 0 0 36px;
  order: 2;
  overflow-y: hidden;
}

#overview-flex > .sidebar-flex > .desktop-sportraxs {
  flex: 0 0 53px;
  order: 5;
  z-index: 2;
  overflow-y: hidden;
}

#profile-map-flex > .desktop-profile {
  flex: 0 0 180px;
  overflow-y: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/desktop.vue